import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EDPNContext } from "../../pages/edpn/EDPNContext";
import { CredentialsContext } from "../../pages/credentials/CredentialsContext";
import { Client, CPTCode, Schedule } from "../../utils/Definitions";
import ProtectedComponent from "../../utils/ProtectedComponent";
import { ProfilePicture } from "../ProfilePicture";
import { GlobalContext } from "../../utils/GlobalContext";
import { ModalNotification } from "../ModalNotification";
import { LOG_CREATION_ENABLED, LOG_CREATION_DISABLED_MESSAGE } from "../LogCreationDisabled";


interface Props {
    Client: Client,
    SetProfilePictureModalActive: React.Dispatch<React.SetStateAction<boolean>>,
    SetSelectedClientForModal: React.Dispatch<React.SetStateAction<Client | null>>,
    SetCredentialsModalActive: React.Dispatch<React.SetStateAction<boolean>>,
    setCredentialsRBTModalActive: any,
}

export const EDPNClientCard: React.FC<Props> = (props) => {

    const globalContext = useContext(GlobalContext);
    const credentialsContext = useContext(CredentialsContext);
    const [billingDaySchedule, setBillingDaySchedule] = useState<Schedule | null>();


    const edpnContext = useContext(EDPNContext);
    const navigate = useNavigate();


    useEffect(() => {
        if (edpnContext.selectedCenter) {
            GetSchdedule();
        }
    }, []);


    const ShowLogCreationDisabled = () => {
        globalContext.setNotificationModalMessage(LOG_CREATION_DISABLED_MESSAGE);
        globalContext.setNotificationModalActive(true);
    };

    function NavigateToAddLog() {
        navigate("/edpn/addlog");
    }

    function NavigateToViewLogs() {
        navigate("/edpn/viewlogs");
    }

    function NavigateToLearnerInfo() {
        navigate("/edpn/learnerinfo");
    }

    function NavigateToAddAbsent() {
        navigate("/edpn/addabsent");
    }


    function WarnUserMissingCredentials() {
        props.SetCredentialsModalActive(true);
    }

    // Returns a popup title if required billing info is missing, otherwise null.
    const GetMissingClientInfoMessage = (): string | null => {
        if (!props.Client.companyInsuranceId) {
            return "This Patient is missing Insurance Information";
        }
        if (!props.Client.therapyScheduleId) {
            return "This Patient is missing a Therapy Schedule";
        }
        return null;
    };

    // Shows the blocking popup if info is missing. Returns true if blocked.
    const BlockIfMissingClientInfo = (): boolean => {
        const missing = GetMissingClientInfoMessage();
        if (missing) {
            globalContext.setNotificationModalMessage(
                missing + ". Please contact your insurance coordinator and ask them to update this information for this patient before you can add a note."
            );
            globalContext.setNotificationModalActive(true);
            return true;
        }
        return false;
    };

    const HandleAddLog = (value?: string) => {
        if (!LOG_CREATION_ENABLED) {
            ShowLogCreationDisabled();
            return;
        }
        if (value) {
            if (BlockIfMissingClientInfo()) return;
            edpnContext.setSelectedClient(JSON.parse(value));
            NavigateToAddLog();
        }
    }

    const HandleAddAbsent = (value?: string) => {
        if (!LOG_CREATION_ENABLED) {
            ShowLogCreationDisabled();
            return;
        }
        if (value) {
            edpnContext.setSelectedClient(JSON.parse(value));
            NavigateToAddAbsent();
        }
    }

    const HandleViewLogs = (value?: string) => {
        if (value) {
            edpnContext.setSelectedClient(JSON.parse(value));
            NavigateToViewLogs();
        }
    }

    function HandleAddLogWithAbsentlearner(value?: string)
    {
        if (!LOG_CREATION_ENABLED) {
            ShowLogCreationDisabled();
            return;
        }

        var tempcodes: CPTCode[] = [];
        if (edpnContext.CPTCodes) {

            // filter CPTcodes by state
            var tempcodes: CPTCode[] = edpnContext.CPTCodes.filter(x => x.value != "H0032" && x.value != "G9012" && x.value != "97152" && x.value != "97156" && x.value != "99366" && x.value != "99368");

            //add michigan codes  (includes test center ID = 21)
            if ((edpnContext.selectedCenter && edpnContext.selectedCenter.state == "MI") || (edpnContext.selectedCenter && edpnContext.selectedCenter.centerId == 21) || (edpnContext.selectedClient && edpnContext.selectedClient.isMimedicaid)) {
                edpnContext.CPTCodes.filter(x => x.value == "H0032" || x.value == "97152").forEach(x => tempcodes.push(x));
            }

            //add G9012 + 97152 for IWOA and EAST MOLINE (includes test center ID = 21)
            if ((edpnContext.selectedCenter && edpnContext.selectedCenter.state == "IA") || (edpnContext.selectedCenter && edpnContext.selectedCenter.centerId == 48) || (edpnContext.selectedCenter && edpnContext.selectedCenter.centerId == 21) || (edpnContext.selectedClient && edpnContext.selectedClient.isIamedicaid)) {
                edpnContext.CPTCodes.filter(x => x.value == "G9012" || x.value == "97152").forEach(x => tempcodes.push(x));
            }

            //add 97156 for IOWA and EAST MOLINE ONLY for RBT, BCBA gets it always
            if (edpnContext.selectedCenter && (edpnContext.selectedCenter.state == "IA" || edpnContext.selectedCenter.centerId == 48 || globalContext.CheckRoles("BCBA"))) {
                edpnContext.CPTCodes.filter(x => x.value == "97156").forEach(x => tempcodes.push(x));
            }

            //add tricare codes for NE, NC, IA, IN, EAST MOLINE, (includes test center ID = 21)
            if (edpnContext.selectedCenter && (edpnContext.selectedCenter.state == "NE" || edpnContext.selectedCenter.state == "NC" || edpnContext.selectedCenter.state == "IA" || edpnContext.selectedCenter.state == "IN" || edpnContext.selectedCenter.centerId == 48 || edpnContext.selectedCenter.centerId == 21)) {
                edpnContext.CPTCodes.filter(x => x.value == "99366" || x.value == "99368").forEach(x => tempcodes.push(x));
            }

            // Filter CPT codes by effective date
            globalContext.GetToken().then((token: any) => {
                globalContext.getCurrentCenterTime(token, edpnContext?.selectedCenter?.centerId).then((billingDate: Date) => {

                    tempcodes = tempcodes.filter(x => {
                        const startDate = x.effectiveDateStart ? new Date(x.effectiveDateStart) : null;
                        const endDate = x.effectiveDateEnd ? new Date(x.effectiveDateEnd) : null;

                        return (
                            (!startDate || startDate <= billingDate || startDate.toDateString() === billingDate.toDateString()) &&
                            (!endDate || endDate >= billingDate || endDate.toDateString() === billingDate.toDateString())
                        );
                    });

                    //filter codes by permissions
                    if (globalContext.CheckRoles("ADMIN")) {
                        //SUPER ADMIN GETS ALL CODES
                        tempcodes = tempcodes;
                    }
                    else if (globalContext.CheckRoles("RBT")) {
                        //RBT
                        tempcodes = tempcodes.filter(x => x.rbtbillable);
                    }
                    else if (globalContext.CheckRoles("BCBA")) {
                        //BCBA
                        tempcodes = tempcodes.filter(x => x.bcbabillable);
                    }
                    else {
                        //not in either group, just default to RBT
                        tempcodes = tempcodes.filter(x => x.rbtbillable);
                    }

                    //filter codes if learner is absent
                    tempcodes = tempcodes.filter(x => x.absentBillable);

                    //sort
                    tempcodes = tempcodes.sort((a, b) => (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity));
                });
            });
        }

        if (tempcodes.length > 0) {
            HandleAddLog(value);
        }
        else {
            globalContext.setNotificationModalMessage("The system did not find any valid billable codes for this absent Patient. If you think this is wrong, please contact IT.");
            globalContext.setNotificationModalActive(true);
        }
    }

    function HandleLearnerInfo() {
        edpnContext.setSelectedClient(props.Client);
        NavigateToLearnerInfo();
    }

    function HandleCornfirmRBTRequiredModal(value?: string) {
        if (!LOG_CREATION_ENABLED) {
            ShowLogCreationDisabled();
            return;
        }
        if (value) {
            if (BlockIfMissingClientInfo()) return;
            edpnContext.setSelectedClient(JSON.parse(value));
            props.setCredentialsRBTModalActive(true);
        }
    }

    function GetSchdedule() {
        var today = new Date;
        var dayID = today.getDay() + 1;

        var schedule = credentialsContext.schedules.find(x => x.therapyScheduleId == props.Client.therapyScheduleId && x.dayOfWeekId == dayID);

        if (schedule) {
            setBillingDaySchedule(schedule);
        }
    }

    const AddLogButton = () => {
        if (props.Client.absent == 0 && (!props.Client.rbtrequired || (props.Client.rbtrequired && globalContext.CoreAccount.therapistData?.credentials && globalContext.CoreAccount.therapistData?.credentials.toLowerCase() != 'bt'))) {
            if (globalContext.CoreAccount.therapistData?.credentials && globalContext.CoreAccount.therapistData.signatureImage) {
                return (
                    <button onClick={(e) => HandleAddLog(JSON.stringify(props.Client))} className="bg-lacblue m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600"><span className="drop-shadow">Add Note</span></button>
                )
            }
            else {
                return (
                    <button onClick={WarnUserMissingCredentials} className="bg-lacblue m-auto w-full h-[3rem] xl:h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600"><span className="drop-shadow">Add Note</span></button>
                )
            }
        }
        else {
            if (props.Client.rbtrequired && globalContext.CoreAccount.therapistData?.credentials && globalContext.CoreAccount.therapistData?.credentials.toLowerCase() == 'bt') {
                return (
                    <button onClick={(e) => HandleCornfirmRBTRequiredModal(JSON.stringify(props.Client))} className="bg-lacblue m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600"><span className="drop-shadow">Add Note</span></button>
                )
            }
            else {
                //absent
                if (globalContext.CheckRoles("BCBA")) {
                    if (globalContext.CoreAccount.therapistData?.credentials && globalContext.CoreAccount.therapistData.signatureImage) {
                        return (
                            <button onClick={(e) => HandleAddLogWithAbsentlearner(JSON.stringify(props.Client))} className="bg-lacblue m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600"><span className="drop-shadow">Add Note</span></button>
                        )
                    }
                    else {
                        return (
                            <button onClick={WarnUserMissingCredentials} className="bg-lacblue m-auto w-full h-[3rem] xl:h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600"><span className="drop-shadow">Add Note</span></button>
                        )
                    }
                }
                else {
                    return (
                        <button className="invisible bg-lacblue m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600"><span className="drop-shadow">Add Note</span></button>
                    )
                }
            }

        }
    }

    const ViewNotesButton = () => {
        return (
            <button onClick={(e) => HandleViewLogs(JSON.stringify(props.Client))} className="bg-lacyellow m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacyellow-600"><span className="drop-shadow">View Notes</span></button>
        )
    }

    const AbsentButton = () => {
        if (props.Client.nonAbsentLogCount == 0 && props.Client.absent == 0) {

            if (globalContext.CoreAccount.therapistData?.credentials && globalContext.CoreAccount.therapistData.signatureImage) {
                return (
                    <button onClick={(e) => HandleAddAbsent(JSON.stringify(props.Client))} className="bg-rose m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-rose-600"><span className="drop-shadow">Absent</span></button>
                )
            }
            else {
                return (
                    <button onClick={WarnUserMissingCredentials} className="bg-rose m-auto w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-rose-600"><span className="drop-shadow">Absent</span></button>
                )
            }
        }
        else {
            return (<></>)
        }
    }

    const LogsToday = () => {
        if (props.Client.absent) {
            return (
                <span className={"text-red"}>Absent</span>
            )
        }
        else {
            return (
                <span>{props.Client.notesCount} ({props.Client.notesTime} hours)</span>
            )
        }
    }


    return (

        <div className={"w-full xl:w-[38rem] bg-gray-50 border drop-shadow rounded flex p-4 " + (props.Client.absent ? "border-red border-2 " : "") + (globalContext.CheckRoles('BCBA') ? 'h-[15rem]' : 'h-[12.5rem]')}>

            {/* Profile Picture Section */}
            <div className="flex flex-col items-center flex-none">
                <ProfilePicture isEditable={false} Client={props.Client} setProfilePictureModalActive={props.SetProfilePictureModalActive} setSelectedClientForModal={props.SetSelectedClientForModal} />
                <span className="mt-2 text-center">{new Date(props.Client.dob).toLocaleDateString()}</span>
            </div>

            {/* Client Info Section */}
            <div className="grid grid-flow-row h-fit w-full ml-8 pl-2">
                <span onClick={HandleLearnerInfo} className="font-bold text-2xl pt-1 cursor-pointer hover:text-lacblue">{props.Client.fullName}</span>

                <span className="mt-1">{props.Client.bucket != null ? (props.Client.bucket ? "Bucket" : "No Bucket") : ""}</span>

                <span className={"mt-1 " + (props.Client.rbtrequired ? "text-red" : "")}>{props.Client.rbtrequired ? "RBT Required" : "RBT NOT Required"}</span>
                <span className="whitespace-nowrap overflow-hidden text-ellipsis max-w-xs">{billingDaySchedule ? new Date(billingDaySchedule.startTime).toLocaleTimeString() + "-" + new Date(billingDaySchedule.endTime).toLocaleTimeString() : "N/A"}</span>

                <span className="font-bold mt-1">POS RESTRICTIONS:</span>
                <span className="text-red">{(props.Client.posrestrictions) ? props.Client.posrestrictions : "N/A"}</span>
                {/*<span className="text-red">{(props.Client.parentalConsentTelehealth && props.Client.telehealthAllowed) ? "N/A" : "Telehealth"}</span>*/}


                <span className={"font-bold mt-1 " + (globalContext.CheckRoles('BCBA') ? '' : 'hidden')}>LOGS TODAY:</span>
                <span className={(globalContext.CheckRoles('BCBA') ? '' : 'hidden')}>{props.Client.logsCount} ({props.Client.logsTime} hours)</span>
            </div>

            <div className="grid grid-rows-3 flex-none p-2">
                <ProtectedComponent RequiredRoles={['EDPN.Write', 'EDPN.Approve']}>
                    <AddLogButton />
                </ProtectedComponent>
                <ViewNotesButton />
                <ProtectedComponent RequiredRoles={['EDPN.Write', 'EDPN.Approve']}>
                    <AbsentButton />
                </ProtectedComponent>

            </div>

        </div>

    )
    
    
};

